/**
 * Legacy photo lists of the service cards (top-level fields of the project), shown and granted by
 * the block project-service-report-data. Two of them do not end in `Attachments`. Must match
 * `PROJECT_SERVICE_REPORT_PHOTO_FIELDS` in apps/apolloserver (services/projectBlocks.ts).
 */
export const PROJECT_SERVICE_REPORT_PHOTO_FIELDS = [
  'serviceBrickCoverWidthAttachments',
  'serviceCorrectBrickHandlingAttachments',
  'serviceBrickAndSubstructureAttachments',
  'serviceCableAndPlugAttachedToRailStateAttachments',
  'serviceCorrectCableInputAttachments',
  'serviceRailOverlappingTerminationFittingAttachments',
  'serviceProtectedUnderBrickCableRoutingAttachments',
  'serviceBrickAndSubstructureOptionalAttachments',
  'serviceStringPlanAttachments',
  'serviceAllPanelsVisibleAttachments',
  'serviceClampAreaAttachments',
  'serviceTrayfDistanceAttachments',
  'serviceRailOverlapAttachments',
  'servicePanelBottomViewAttachments',
  'serviceSolarPanelsOptionalAttachments',
  'serviceCableManagementAttachments',
  'serviceCableAlongFacadeAttachments',
  'serviceCableManagementOptionalAttachments',
  'serrviceHakLockedAttachments',
  'serviceHakAttachments',
  'serviceHakAndZsSameRoomAttachments',
  'serviceZsWithCoverAttachments',
  'serviceZsWithoutCoverAttachments',
  'serviceZsSerialNumberAttachments',
  'serviceZsPostCounterAreaAttachments',
  'serviceZsPreCounterAreaAttachments',
  'serviceZsDistributionAreaAttachments',
  'serviceAdditionalSubDistributionAttachments',
  'serviceDisassembledMetersAttachments',
  'serviceMainElectricMeterAttachments',
  'serviceSeconaryElectricMeterAttachments',
  'serviceInstallationLocationWithInverterAndMateboxAttachments',
  'serviceSecondaryInstallationLocationAttachments',
  'serviceCablePath360Attachments',
  'serviceOpenMatebox',
  'mtbxLabelSnAttachments',
  'invLabelSnAttachments',
  'batLabelSnAttachments',
  'serviceEarthingAttachments',
  'serviceWallboxLocationAttachments',
  'serviceWallboxCablePathNotes',
  'serviceWallboxAttachments',
  'serviceWallboxAccessCardAttachments',
  'serviceFiLsWallboxAttachments',
  'serviceMiscOptionalAttachments',
];
